import type {AxiosError, AxiosResponse} from 'axios';
import {UseMutationOptions, useMutation} from '@tanstack/react-query';

import {api} from '@eksab/api';

interface GenerateGuestTokenRequest {
  grant_type: 'guest';
  client_id: '2';
  scope: 'guest';
}

interface GenerateGuestTokenResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: string;
  extra: {
    type: 'guest';
    guest_id: string;
    additional: string;
  };
}

export const useGenerateGuestTokenMutation = (options?: UseMutationOptions<GenerateGuestTokenResponse, AxiosError>) =>
  useMutation<GenerateGuestTokenResponse, AxiosError>(
    () =>
      api
        .post<GenerateGuestTokenResponse, AxiosResponse<GenerateGuestTokenResponse>, GenerateGuestTokenRequest>(
          'v2/oauth/token',
          {
            grant_type: 'guest',
            client_id: '2',
            scope: 'guest',
          },
        )
        .then((res) => res.data),
    options,
  );
